import Reflux from "reflux";

import { createPathMatcher, getPageFromUrl } from "@javascript/helpers/urlUtilities";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import { FacetSearchGeoCoordinatesActions } from "@javascript/stores/actions/facetSearch/geoCoordinatesActions";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

/**
 * Renders the geographic coordinates filter chip when coordinates are set.
 * Coordinates are locked when present in the original feed query.
 *
 * @component
 * @listens {FacetSearchStore} Subscribes to geoCoordinates
 */
const FacetSearchCriteriaGeoCoordinates = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, ({ geoCoordinates }) => ({ geoCoordinates }))
  ],

  getInitialState() {
    return {
      geoCoordinates: FacetSearchStore.data.geoCoordinates
    };
  },

  render() {
    const { geoCoordinates } = this.state;

    // Early return if no coordinates exist
    if (!geoCoordinates?.bottom_right_lat) {
      return null;
    }

    const PAGE_PATTERNS = [
      {
        pattern: "mapping",
        matcher: createPathMatcher(['mapping'])
      },
    ];

    const page = getPageFromUrl(PAGE_PATTERNS, "facet_search");
    const isMappingPage = page === "mapping";

    const hasOriginalMappingQuery = Boolean(Zymewire.original_feed_query?.geo_box);

    const isLocked = isMappingPage || hasOriginalMappingQuery;

    return <GeoCoordinatesEntry locked={isLocked} />;
  }
});


/**
 * React component that actually displays the notice that mapping was used to filter a query. If the entry is a locked entry, as permitted on the feed view, then the entry's remove functions are disabled.
 *
 * @param {Boolean} locked is the filter removable or not
 */

const GeoCoordinatesEntry = ({ locked }) => {

  const removeGeoCoordinates = () => {
    // remove_geo_box();
    //
    //
    // found 2 instances of remove_geo_box -- different outcomes, same method name -- the outcome depends on context:
    //
    // if on the mapping page
    //
    //     var cntr = new google.maps.LatLng(25.0, -30.0);
    //     window.myMap.setCenter(cntr);
    //     window.myMap.setZoom(2);
    //     Zymewire.geo_box = current_bounding_box();

    // otherwise:
    //
    //   Zymewire.geo_box = null;
    //   doEventSearch();
    //
    //
    // the curious thing is that the call to doEventSearch() only occurs if you're not on the mapping page -- timebox
    // prevented investigation as to why and what's happening

    let bounds = {...FacetSearchGeoCoordinatesSlice};
    let doSearch = true;

    if(window.myMap) {
      const mapCenter = new google.maps.LatLng(25.0, -30.0);
      window.myMap.setCenter(mapCenter);
      window.myMap.setZoom(2);
      bounds = bounds_to_geo_box(window.myMap.getBounds());
      doSearch = false;
    }
    // need a story to deprecate the Zymewire.geo_box part of the kitchen sink
    // any logic requiring "geo_box" should get it from the store as the single source of truth
    Zymewire.geo_box = bounds;
    FacetSearchGeoCoordinatesActions.geoCoordinatesUpdate(bounds, { doSearch: doSearch, triggerStateUpdate: false });
    return false;
  };

  return (
    <Chip
      className="search_filter_applied_chip"
      label="Companies in the mapped area"
      leadingIcon={"mapping"}
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeGeoCoordinates,
      }}
      variant="secondary"
    />
  )
}

window.FacetSearchCriteriaGeoCoordinates = FacetSearchCriteriaGeoCoordinates;
export default FacetSearchCriteriaGeoCoordinates;
